export default {
  data: () => ({
    updatingPickupSchedule: false,
    pickupScheduleSaveState: 'idle',
    pickupScheduleSaveTimer: null,
    pickupScheduleSavePending: false,
    pickupScheduleChangeVersion: 0,
  }),
  computed: {
    canQuickSavePickupSchedule() {
      return Boolean(this.form && this.form._id) && this.onCreate !== true;
    },
    pickupScheduleSaveMessage() {
      if (this.pickupScheduleSaveState === 'saving') return 'กำลังบันทึก...';
      if (this.pickupScheduleSaveState === 'saved') {
        return 'บันทึกแล้ว พิมพ์ได้เลย';
      }
      if (this.pickupScheduleSaveState === 'error') {
        return 'บันทึกไม่สำเร็จ กรุณาลองใหม่';
      }
      return '';
    },
  },
  beforeDestroy() {
    if (this.pickupScheduleSaveTimer) {
      clearTimeout(this.pickupScheduleSaveTimer);
    }
  },
  methods: {
    onPickupDateChange(value) {
      this.form.pick_up_date = value;
      this.queuePickupScheduleSave();
    },
    onPickupTimeChange(value) {
      this.form.pick_up_time = value;
      this.queuePickupScheduleSave();
    },
    onPickupVisibilityChange(value) {
      this.$set(this.form, 'show_pickup', value === true);
      this.queuePickupScheduleSave();
    },
    queuePickupScheduleSave() {
      if (!this.canQuickSavePickupSchedule) return;

      this.pickupScheduleChangeVersion += 1;
      this.pickupScheduleSaveState = 'saving';
      if (this.pickupScheduleSaveTimer) {
        clearTimeout(this.pickupScheduleSaveTimer);
      }
      this.pickupScheduleSaveTimer = setTimeout(() => {
        this.pickupScheduleSaveTimer = null;
        this.savePickupSchedule();
      }, 500);
    },
    async savePickupSchedule() {
      if (!this.canQuickSavePickupSchedule) return;
      if (this.updatingPickupSchedule) {
        this.pickupScheduleSavePending = true;
        return;
      }

      this.updatingPickupSchedule = true;
      this.pickupScheduleSavePending = false;
      const changeVersion = this.pickupScheduleChangeVersion;
      try {
        const body = {
          token: this.$jwt.sign(
            {
              document_id: this.form._id,
              show_pickup: this.form.show_pickup === true,
              pick_up_date: this.form.pick_up_date || '',
              pick_up_time: this.form.pick_up_time || '',
            },
            this.$privateKey,
            { noTimestamp: true }
          ),
        };
        await this.$axios.post(
          `${this.$baseUrl}/document/set_pickup_schedule`,
          body
        );
        await this.getDataPrint(this.form._id);
        if (
          !this.pickupScheduleSavePending &&
          changeVersion === this.pickupScheduleChangeVersion
        ) {
          this.pickupScheduleSaveState = 'saved';
        }
      } catch (err) {
        this.pickupScheduleSaveState = 'error';
      } finally {
        this.updatingPickupSchedule = false;
        if (this.pickupScheduleSavePending) {
          this.savePickupSchedule();
        }
      }
    },
  },
};
